import upcomingevent from '../assets/event-upcoming.png';

export const UPCOMING = [
    {
        image: upcomingevent,
        title: 'Bread for the Journey Fall Table',
        date: 'October 8, 2020 at 5:30pm CST',
        description:
            'Every fall we invite friends, family and colleagues to the Bread for the Journey Omaha annual celebration and fundraiser. We know you have many ways to share your gifts, and we appreciate that you make this event one that...',
        link: '#',
    },
    {
        image: upcomingevent,
        title: 'Bread for the Journey Fall Table',
        date: 'October 8, 2020 at 5:30pm CST',
        description:
            'Every fall we invite friends, family and colleagues to the Bread for the Journey Omaha annual celebration and fundraiser. We know you have many ways to share your gifts, and we appreciate that you make this event one that...',
        link: '#',
    },
    {
        image: upcomingevent,
        title: 'Bread for the Journey Fall Table',
        date: 'October 8, 2020 at 5:30pm CST',
        description:
            'Every fall we invite friends, family and colleagues to the Bread for the Journey Omaha annual celebration and fundraiser. We know you have many ways to share your gifts, and we appreciate that you make this event one that...',
        link: '#',
    },
];
